<script>
import "./vfigma.input.scss";

export default {
  // props: ["input", "placeholder", "disabled", "enter", "esc", "optional", "focus", "blur"],
  props: {
    defaultvalue: Number,
    placeholder: String,
    disabled: Boolean,
    enter: Function,
    esc: Function,
    optional: Boolean,
    focus: Function,
    title: String,
    click: Function,
    readonly: Boolean,
    min: Number,
    max: Number,
  },
  data() {
    return {
      value: 0,
      focused: false,
      input: "",
    };
  },
  methods: {
    keyup: function ($event) {
      if ($event.which == 13) {
        $($event.target).blur();
      }
    },
    stepUp: function ($event) {
      if (this.input == this.max) return;
      this.value = this.value + 1;
    },
    stepDown: function ($event) {
      if (this.input == "00:00:00") return;
      if (this.input == this.min) return;
      this.value = this.value - 1;
    },
    blur: function (input) {
      let splittedInput = input.split(":");

      console.log(splittedInput);

      if (splittedInput.length >= 2 && splittedInput.length <= 3) {
        let v = parseInt(splittedInput[splittedInput.length - 1]);
        v = v + parseInt(splittedInput[splittedInput.length - 2] * 60);
        v =
          v +
          (splittedInput[splittedInput.length - 3]
            ? parseInt(splittedInput[splittedInput.length - 3] * 3600)
            : 0);
        this.value = v;
      } else {
        this.value = parseInt(input);
      }
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 58
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    format(v) {
      let totalSeconds = v;

      let hours = parseInt(totalSeconds / 3600);
      totalSeconds = totalSeconds % 3600;

      let minutes = parseInt(totalSeconds / 60);
      totalSeconds = totalSeconds % 60;

      let seconds = totalSeconds;

      hours = String(hours).length < 2 ? "0" + hours : hours;
      minutes = String(minutes).length < 2 ? "0" + minutes : minutes;
      seconds = String(seconds).length < 2 ? "0" + seconds : seconds;

      return hours + ":" + minutes + ":" + seconds;
    },
  },
  mounted: function () {
    this.value = this.defaultvalue;
    this.input = this.format(this.defaultvalue);
  },
  watch: {
    defaultvalue: function (v) {
      this.value = this.defaultvalue;
    },
    value: function (v) {
      this.input = this.format(v);
      this.$emit("change", this.value);
    },
  },
};
</script>

<template>
  <div class="f-time">
    <f-field :optional="optional" :focused="focused">
      <template v-slot:label><slot name="label"></slot></template>
      <template v-slot:content>
        <div class="f-input-container" :class="{ focus: focused }">
          <input
            class="keepfocus f-input"
            :value="input"
            :placeholder="placeholder"
            :disabled="disabled"
            :readonly="readonly"
            :title="title"
            @keyup="keyup($event)"
            @keypress="isNumber($event)"
            @focus="
              focused = true;
              $emit('focus', $event);
            "
            @blur="
              focused = false;
              blur($event.target.value);
            "
            @click="$emit('click', $event)"
            v-on:keyup.enter="$emit('enter')"
            v-on:keyup.esc="$emit('esc')"
            type="text"
          />
          <div class="f-right">
            <div class="f-action">
              <slot name="action"></slot>
              <div class="f-stepper-actions">
                <div @click="stepUp()">
                  <f-icon icon="fa6-angle-up"></f-icon>
                </div>
                <div @click="stepDown()">
                  <f-icon icon="fa6-angle-down"></f-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:helper v-if="$slots.helper"
        ><slot name="helper"></slot
      ></template>
    </f-field>
  </div>
</template>

<style scoped lang="scss">
</style>